import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { width = 24, height = 24, color = '#363531' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M4.5 6.25a.5.5 0 00-.5.5v10.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V6.75a.5.5 0 00-.5-.5h-15zm-2.5.5a2.5 2.5 0 012.5-2.5h15a2.5 2.5 0 012.5 2.5v10.5a2.5 2.5 0 01-2.5 2.5h-15a2.5 2.5 0 01-2.5-2.5V6.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M8.118 12.229H3.5V10.25s4.267.003 4.82 0a1.74 1.74 0 011.716 1.399 2.01 2.01 0 003.928 0 1.74 1.74 0 011.717-1.399h4.892v1.979h-4.691a4.01 4.01 0 01-7.764 0zM2 8.25a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
